var exports = {
  "i": "xaee3c4fa--92c879--wrapper",
  "P": "xaee3c4fa--92c879--inner-wrapper",
};

module.exports = exports;
